import EmblaCarousel, { EmblaCarouselType } from "embla-carousel"
import ClassNames from "embla-carousel-class-names"

const addThumbBtnsClickHandlers = (
  emblaApiMain: EmblaCarouselType,
  emblaApiThumb: EmblaCarouselType,
): (() => void) => {
  const slidesThumbs = emblaApiThumb.slideNodes()

  const scrollToIndex = slidesThumbs.map(
    (_, index) => (): void => emblaApiMain.scrollTo(index),
  )

  slidesThumbs.forEach((slideNode, index) => {
    slideNode.addEventListener("click", scrollToIndex[index], false)
  })

  return (): void => {
    slidesThumbs.forEach((slideNode, index) => {
      slideNode.removeEventListener("click", scrollToIndex[index], false)
    })
  }
}

const addToggleThumbBtnsActive = (
  emblaApiMain: EmblaCarouselType,
  emblaApiThumb: EmblaCarouselType,
): (() => void) => {
  const slidesThumbs = emblaApiThumb.slideNodes()

  const toggleThumbBtnsState = (): void => {
    emblaApiThumb.scrollTo(emblaApiMain.selectedScrollSnap())
    const previous = emblaApiMain.previousScrollSnap()
    const selected = emblaApiMain.selectedScrollSnap()
    slidesThumbs[previous].classList.add("opacity-30")
    slidesThumbs[selected].classList.remove("opacity-30")
  }

  emblaApiMain.on("select", toggleThumbBtnsState)
  emblaApiThumb.on("init", toggleThumbBtnsState)

  return (): void => {
    const selected = emblaApiMain.selectedScrollSnap()
    slidesThumbs[selected].classList.add("opacity-30")
  }
}

export default (slidesLength, showNav) => ({
  emblaNode: null,
  emblaThumbsNode: null,
  initEmbla() {
    const { embla, next, prev, emblaThumbs } = this.$refs

    this.emblaNode = EmblaCarousel(
      embla,
      {
        align: "center",
        loop: true,
        dragFree: true,
        inViewThreshold: 0.85,
      },
      [ClassNames()],
    )

    if (showNav && emblaThumbs) {
      this.emblaThumbsNode = EmblaCarousel(emblaThumbs, {
        containScroll: "keepSnaps",
        dragFree: true,
        // loop: true,
        // align: "center",
      })

      const removeThumbBtnsClickHandlers = addThumbBtnsClickHandlers(
        this.emblaNode,
        this.emblaThumbsNode,
      )

      const removeToggleThumbBtnsActive = addToggleThumbBtnsActive(
        this.emblaNode,
        this.emblaThumbsNode,
      )

      this.emblaNode.on("destory", removeThumbBtnsClickHandlers)
      this.emblaNode.on("destory", removeToggleThumbBtnsActive)

      this.emblaThumbsNode.on("destory", removeThumbBtnsClickHandlers)
      this.emblaThumbsNode.on("destory", removeToggleThumbBtnsActive)
    }

    next?.addEventListener("click", this.emblaNode.scrollNext, false)
    prev?.addEventListener("click", this.emblaNode.scrollPrev, false)
  },
  duplicateSlides() {
    const { embla } = this.$refs
    const emblaContainer = embla.querySelector("ul")
    const slides = emblaContainer.querySelectorAll("li")
    slides.forEach(slide => {
      const clone = slide.cloneNode(true)
      emblaContainer.appendChild(clone)
    })
  },
  init() {
    if (slidesLength === 2) {
      this.duplicateSlides()
    }
    slidesLength > 1 && this.initEmbla()
  },
})
